function avoidBreakInside(args) {
  const base = {
    ["data-avoid-break-inside"]: args?.force ? "force" : "true"
  };
  if (args?.extend?.top) {
    base["data-extend-top-by"] = String(args.extend.top);
  }
  if (args?.extend?.bottom) {
    base["data-extend-bottom-by"] = String(args.extend.bottom);
  }
  return base;
}
function avoidBreakAfter() {
  return {
    ["data-avoid-break-after"]: "true"
  };
}
function avoidBreakSnapPoint(args) {
  const base = {
    ["data-avoid-break-snap-point"]: "true"
  };
  if (args?.extend?.top) {
    base["data-extend-top-by"] = String(args.extend.top);
  }
  if (args?.extend?.bottom) {
    base["data-extend-bottom-by"] = String(args.extend.bottom);
  }
  return base;
}

export { avoidBreakAfter, avoidBreakInside, avoidBreakSnapPoint };
//# sourceMappingURL=dom-modifiers.js.map
